import * as React from 'react';

import { ServiceOptionItem } from '../types';
import { CartService, OnDeleteItemType } from '../../Cart/types';
import { ServiceSummary } from '../../features/service-summary';
import { SelectedInsuranceFragment } from '@websky/graphql';
import { getSelectedInsuranceDownloadAction } from '@shared/lib/insurance';

interface Props {
	children: (content: ServiceOptionItem[]) => React.ReactElement;
	onServiceDelete?: OnDeleteItemType;
	isDownload?: boolean;
	isConfirmed?: boolean;
	onDownloadVskInsurance?: () => Promise<void>;
	selectedInsurances: SelectedInsuranceFragment[];
	mode?: 'default' | 'aggregator';
}

const InsuranceSummary: React.FC<Props> = props => {
	const selectedInsurancesByCode = new Map<string, SelectedInsuranceFragment>();

	for (const insurance of props.selectedInsurances ?? []) {
		const code = insurance.insuranceProgram?.code;

		if (code) {
			selectedInsurancesByCode.set(code, insurance);
		}
	}

	return (
		<ServiceSummary
			serviceType="Insurance"
			mode={props.mode}
			renderSummary={groups => {
				const items = groups.reduce<ServiceOptionItem[]>(
					(items, group) => [
						...items,
						...group.items
							.filter(item => selectedInsurancesByCode.has(item.id))
							.map<ServiceOptionItem>(item => {
								const selectedInsurance = selectedInsurancesByCode.get(item.id);

								const downloadAction =
									props.isDownload && selectedInsurance
										? getSelectedInsuranceDownloadAction(
												selectedInsurance,
												!!props.isConfirmed,
												props.onDownloadVskInsurance
										  )
										: null;

								return {
									...item,
									included: !props.onServiceDelete || item.included,
									downloadUrl: props.isDownload ? item.downloadUrl : null,
									onDownload: downloadAction?.onDownload,
									onDelete:
										props.onServiceDelete && item.deleteMeta
											? () => props.onServiceDelete(CartService.Insurances, item.deleteMeta)
											: null
								};
							})
					],
					[]
				);

				return props.children(items);
			}}
		/>
	);
};

export default InsuranceSummary;
